import Form from "react-bootstrap/Form";

type SetSessionLimitSliderProps = {
  serial: string;
  circuitAmpLimit: number;
  currentSessionLimit: number | null | undefined;
  onChange: (value: number) => void;
  disabled?: boolean;
};

const AMP_OPTIONS = [6, 10, 16, 20, 25, 32];

export default function SetSessionLimitSlider({
  serial,
  circuitAmpLimit,
  currentSessionLimit,
  onChange,
  disabled = false,
}: SetSessionLimitSliderProps) {
  const options = AMP_OPTIONS.filter((a) => a <= circuitAmpLimit);
  const value = currentSessionLimit ?? circuitAmpLimit ?? 6;
  const displayValue = options.includes(value) ? value : (options[options.length - 1] ?? 6);

  return (
    <div id="SetSessionLimitSlider" className="mx-2">
      <Form.Select
        value={displayValue}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        aria-label="Session limit (amps)"
      >
        {options.map((amp) => (
          <option key={amp} value={amp}>
            {amp} A
          </option>
        ))}
      </Form.Select>
      <p className="text-center text-secondary pt-2 mb-0 small">
        Circuit amp limit: {circuitAmpLimit} A
      </p>
    </div>
  );
}
